import { render, staticRenderFns } from "./TableField.vue?vue&type=template&id=cfa6d4b0"
import script from "./TableField.vue?vue&type=script&lang=js"
export * from "./TableField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports